import React from 'react';
import BookYourEventStyle from './style';
import { useSelector } from 'react-redux';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';
import { contentfulSelector } from 'src/redux/selectors/contentfulSelector';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

const BookYourEvent: React.FC = () => {
    const { tourName = '', isEvent } = useSelector(quoteDetailSelector);

    const {
        quoteWhyBookWithYgtTheMasters,
        quoteWhyBookWithYgtTheRyderCup,
        quoteWhyBookWithYgtTheOpen,
        quoteWhyBookWithYgtTheUsOpen,
        quoteWhyBookWithYgtSolheimCup,
        quoteWhyBookWithYgtThePlayersChamps,
        quoteWhyBookWithYgtRaceToDubai,
        quoteWhyBookWithYgtPgaTour,
        quoteWhyBookWithYgtDpWorldTour,
    } = useSelector(contentfulSelector);

    const getDataWhyBook = (tour: string) => {
        let dataWhyBook: any;
        switch (true) {
            case tour.includes('Masters'):
                dataWhyBook = quoteWhyBookWithYgtTheMasters;
                break;
            case tour.includes('Ryder'):
                dataWhyBook = quoteWhyBookWithYgtTheRyderCup;
                break;
            case tour.includes('The Open'):
                dataWhyBook = quoteWhyBookWithYgtTheOpen;
                break;
            case tour.includes('US Open'):
                dataWhyBook = quoteWhyBookWithYgtTheUsOpen;
                break;
            case tour.includes('Solheim'):
                dataWhyBook = quoteWhyBookWithYgtSolheimCup;
                break;
            case tour.includes('Players'):
                dataWhyBook = quoteWhyBookWithYgtThePlayersChamps;
                break;
            case tour.includes('Dubai'):
                dataWhyBook = quoteWhyBookWithYgtRaceToDubai;
                break;
            case tour.includes('PGA'):
                dataWhyBook = quoteWhyBookWithYgtPgaTour;
                break;
            case tour.includes('DP'):
                dataWhyBook = quoteWhyBookWithYgtDpWorldTour;
                break;
            default:
                dataWhyBook = quoteWhyBookWithYgtTheMasters;
                break;
        }

        const formatData = dataWhyBook?.content[0]?.content || [];

        return formatData.map(
            (item: any) => item?.content[0]?.content[0]?.value,
        );
    };

    const dataWhyBookEvent = getDataWhyBook(tourName);

    return (
        <>
            {isEvent && dataWhyBookEvent.length > 0 && (
                <BookYourEventStyle>
                    <div className="title-card">Book Your Event with the Golf Experts</div>
                    <div className="why-book">
                        {dataWhyBookEvent.map((item: any, index: any) => (
                            <div className="item" key={index}>
                                <FontAwesomeIcon
                                    className="icon-check"
                                    icon={faCircleCheck}
                                />
                                <p>{item}</p>
                            </div>
                        ))}
                    </div>
                </BookYourEventStyle>
            )}
        </>
    );
};

export default BookYourEvent;
